module.exports = __webpack_public_path__ + "media/images/emblems/Duedingen-coat_of_arms-6195e592a0da130ffceb7b172ab910d7.svg";